import { APIOutput, IPageFeedback } from "@amzn/ask-legal-domain";
import { API as RestAPI } from "aws-amplify";
import { AppContextValue } from "../setup/context-value";
import { APIResponse, toDefaultRequestPayload } from "./common";

export interface PageFeedbackAPI {
    submit(input: IPageFeedback.SubmitFeedbackInput): Promise<APIResponse<IPageFeedback.SubmitFeedbackOutput>>;
    load(input: IPageFeedback.LoadFeedbackInput): Promise<APIResponse<IPageFeedback.LoadFeedbackOutput>>;
    update(input: IPageFeedback.UpdateFeedbackInput): Promise<APIResponse<IPageFeedback.UpdateFeedbackOutput>>;
}

export class PageFeedbackAPIImpl implements PageFeedbackAPI {
    constructor(private context: AppContextValue) {}

    async submit(input: IPageFeedback.SubmitFeedbackInput): Promise<APIResponse<IPageFeedback.SubmitFeedbackOutput>> {
        const response: APIResponse<IPageFeedback.SubmitFeedbackOutput> = await RestAPI.post(
            "custom-domain",
            "/page-feedback/submit",
            toDefaultRequestPayload(input)
        );
        return response;
    }

    async load(input: IPageFeedback.LoadFeedbackInput): Promise<APIResponse<IPageFeedback.LoadFeedbackOutput>> {
        const response: APIResponse<IPageFeedback.LoadFeedbackOutput> = await RestAPI.post(
            "custom-domain",
            "/page-feedback/load",
            toDefaultRequestPayload(input)
        );
        return response;
    }

    async update(input: IPageFeedback.UpdateFeedbackInput): Promise<APIResponse<IPageFeedback.UpdateFeedbackOutput>> {
        const response: APIResponse<IPageFeedback.UpdateFeedbackOutput> = await RestAPI.post(
            "custom-domain",
            "/page-feedback/update",
            toDefaultRequestPayload(input)
        );
        return response;
    }
}
